<irembogov-time-picker
  [labelForId]="field.key"
  [customFormControl]="formControl"
  [endHour]="field.props['endHour']"
  [startHour]="field.props['startHour']"
  [interval]="field.props['interval']"
  [appendTo]="field.props['appendTo']"
  [dropdownPosition]="field.props['dropdownPosition'] ?? 'auto'"
  [placeholder]="
    field.props.placeholder ? field.props.placeholder : ''
  "></irembogov-time-picker>
